// src/crm/CrmLayout.tsx
import { Outlet } from 'react-router-dom'

export function CrmLayout() {
  return <Outlet />
}
